import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { withRouter } from 'react-router-dom'


const styles = theme => ({
  title: {
    fontWeight: 400,
    cursor: 'pointer',
    color: theme.palette.primary.contrastText
  },
  toolBar: {
    display: 'flex',
    justifyContent: 'center'
  },
  bar: {
    maxWidth: theme.contentWidth.main,
    width: '100%'
  }
});

function NavBar(props) {
  const { classes, history } = props;

  return (
    <AppBar position="static" color="primary">
        <Toolbar variant="dense" className={classes.toolBar}>
          <div className={classes.bar}>
            <Typography variant="title" onClick={() => history.push('/')} className={classes.title}>
              夢想貼圖產生器
            </Typography>
          </div>
        </Toolbar> 
    </AppBar>
  );
}

export default withRouter(withStyles(styles)(NavBar));


// WEBPACK FOOTER //
// ./src/NavBar.js